import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div`
  display: flex;
  flex-flow: column wrap;
  font-size: ${rem(12)};
  line-height: ${rem(16)};
`;

const Title = styled.h5<{ color?: string }>(
  ({ color }) => `
  color: inherit;
  display: flex;
  font-size: ${rem(14)};
  font-weight: 600;
  line-height: ${rem(20)};
  gap: ${rem(8)};
  margin-bottom: ${rem(12)};

  ${
    color &&
    `&::before {
      content: '';
      background: ${color};
      display: block;
      border-radius: 50%;
      flex-shrink: 0;
      margin-top: ${rem(4.5)};
      width: 10px;
      height: 10px;
    }`
  }`
);

const Description = styled.p`
  font-weight: 400;
  margin-bottom: ${rem(16)};
  max-height: ${rem(64)};
  overflow-y: auto;
  padding-right: ${rem(4)};
  text-wrap: balance;

  &&::-webkit-scrollbar {
    width: ${rem(8)};
  }

  &&::-webkit-scrollbar-thumb {
    border-width: ${rem(2)};
  }
`;

const Footer = styled.div`
  color: ${({ theme }) => theme.palette.common.black};
  margin-top: ${rem(24)};

  .button {
    font-size: ${rem(14)};
    white-space: nowrap;
  }
`;

const Meta = styled.dl`
  display: grid;
  grid-template-columns: 46% 1fr;
  gap: ${rem(8)} ${rem(4)};
`;

const MetaLabel = styled.dt`
  display: flex;
  align-items: center;
  font-weight: 600;
  line-height: ${rem(16)};
`;

const MetaValue = styled.dd`
  display: flex;
  align-items: center;
  column-gap: ${rem(4)};
  font-weight: 400;
`;

const AudienceIcon = styled.span`
  display: inline-flex;
  align-items: center;

  .icon {
    width: ${rem(12)};
    height: ${rem(12)};
  }
`;

const AudienceDescription = styled.span`
  font-size: inherit;
  text-transform: capitalize;
`;

export default {
  Wrapper,
  Title,
  Description,
  Footer,
  Meta,
  MetaLabel,
  MetaValue,
  AudienceIcon,
  AudienceDescription
};
